import React from "react";
import { Box } from "@mui/system";
import { Button } from "@mui/material";
import { Plan } from "../constants";

export function PlanSelector({
  selectedPlan,
  onSelectPlan,
}: {
  selectedPlan: Plan;
  onSelectPlan: (planId: Plan["id"]) => void;
}) {
  return (
    <Box
      sx={{
        position: "relative",
        display: "grid",
        gridTemplateColumns: "100px 100px",
        gridTemplateRows: "2.5rem",
        gridTemplateAreas: '"left right"',
        placeItems: "stretch",
        padding: "4px",

        border: "solid 1px rgb(90% 90% 90%)",
        bgcolor: "background.paper",
        borderRadius: "4px",
      }}
    >
      <Box
        sx={{
          gridArea: "left",
          bgcolor: "brand.blue.main",
          borderRadius: "4px",

          position: "relative",
          transition: "left 0.2s ease-in-out",
          left: selectedPlan.id == "free" ? "0%" : "100%",
        }}
      ></Box>
      <Button
        sx={{
          gridArea: "left",
          fontWeight: "500",

          textAlign: "center",
          verticalAlign: "center",
          "&:hover": { bgcolor: "transparent" },

          transition: "color 0.2s linear",
          color: selectedPlan.id == "free" ? "white" : "text.secondary",
        }}
        onClick={() => onSelectPlan("free")}
      >
        Developer
      </Button>
      <Button
        sx={{
          gridArea: "right",

          transition: "color 0.2s linear",
          color: selectedPlan.id == "on_demand" ? "white" : "text.secondary",

          "&:hover": { bgcolor: "transparent" },
        }}
        onClick={() => onSelectPlan("on_demand")}
      >
        Team
      </Button>
    </Box>
  );
}
